import { Component, ContentChild, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-app-shell',
  templateUrl: './app-shell.component.html',
  styleUrls: ['./app-shell.component.scss']
})
export class AppShellComponent implements OnInit {
  @ContentChild(RouterOutlet) isContentHasRouter: RouterOutlet | undefined; // trying to find router outlet presesnce in projected content

  constructor() {

  }

  ngOnInit(): void {
  }

}
